import { canv } from "@/canv/global";
import { getTarget } from "@/canv/utils";
import { generateColor } from "@/helpers/generateColor";
import { getInitials } from "@/helpers/getInitials";
import { t } from "@/i18n";

export class UsersWindow {
    show() {
        const usersWindowWrapper = document.createElement("div");
        usersWindowWrapper.classList.add("usersWindowWrapper");

        document.body.append(usersWindowWrapper);

        usersWindowWrapper.innerHTML = this.getWindow();

        this.reFillUsers();
        this.initUsers();
    }

    close() {
        const usersWindow = document.getElementsByClassName("usersWindowWrapper")[0];
        if (usersWindow !== undefined) {
            usersWindow.outerHTML = "";
        }
    }

    reFillUsers() {
        const otherUsers = canv.multiManager.getListedUsers();
        const users = otherUsers
            .map((user) => {
                return this.getUserTemplate(user.name, user.color, user.sessionUID);
            })
            .join("");

        const usersWindowUsersCount = document.querySelector(".usersWindowUsersCount");
        if (usersWindowUsersCount) {
            usersWindowUsersCount.innerHTML = t("users.count", {
                count: otherUsers.length + 1,
            });
        }

        const usersWindowOtherUsers = document.querySelector(".usersWindowOtherUsers");
        if (usersWindowOtherUsers) {
            usersWindowOtherUsers.innerHTML = users;
            const elements = document.querySelectorAll(".hiddenUserWindow");
            const styleText = users.length > 1 ? "block" : "none";
            elements.forEach((element) => {
                (element as HTMLElement).style.setProperty("display", styleText);
            });

            const userItems = usersWindowOtherUsers.getElementsByClassName("usersWindowItem");
            for (let i = 0; i < userItems.length; i++) {
                userItems[i].addEventListener("mousedown", this.userClick.bind(this), false);
            }
        }
    }

    initUsers() {
        // wrapper
        const markUsersWindowWrapper = document.getElementsByClassName("usersWindowWrapper")[0];
        markUsersWindowWrapper.addEventListener("mousedown", this.wrapperClick.bind(this), false);

        const callUsersBtn = document.getElementsByClassName("usersWindowCallUsersBtn")[0];
        callUsersBtn.addEventListener("mousedown", this.callUsersClick.bind(this), false);
    }

    userClick(e: Event) {
        const monet = getTarget(e, "usersWindowItem");
        const sessionUID = monet?.getAttribute("sessionUID");

        if (!sessionUID) {
            return;
        }

        if (sessionUID !== canv.multiManager.viewSubscribeUID) {
            canv.multiManager.prioritizeMultiUser(sessionUID);
        }

        canv.multiManager.tryViewSubscribe(sessionUID);
    }

    wrapperClick(e: Event) {
        const tryInner = getTarget(e, "usersWindow");
        if (tryInner === null) {
            this.close();
        }
    }

    callUsersClick() {
        if (canv.multiManager.hasListedUsers()) {
            canv.intercom.fastMessage("cursor_follow_invite", {
                sessionUID: canv.sessionUID,
            });
            this.close();
        }
    }

    // Templates

    getUserTemplate(name: string, color: string, sessionUID?: string) {
        let selectorOn = "";
        if (
            canv.multiManager.viewSubscribeUID !== "" &&
            canv.multiManager.viewSubscribeUID === sessionUID
        ) {
            selectorOn = " usersWindowItemSelectorOn";
        }

        const me = sessionUID ? "" : " usersWindowItemMe";

        return `
            <div class="usersWindowItem usersWindowItemSelector${me}${selectorOn}" sessionUID=${sessionUID}>
                <div class="usersWindowItemLogo" style="background-color: ${color}"><p>${getInitials(name)}</p></div>
                <div class="usersWindowItemName">${name}</div>
            </div>
        `;
    }

    getWindow() {
        const me = this.getUserTemplate(
            canv.getInitDataProp("userName"),
            generateColor(canv.getInitDataProp("userToken")),
        );

        return `
            <div class="usersWindow scrollable">
                <div class="usersWindowUsersCount"></div>
                <div class="divider"></div>
                <div class="usersWindowMeBlockContainer">
                    ${me}
                    <button class="usersWindowCallUsersBtn hiddenUserWindow">
                        ${t("users.inviteAll")}
                    </button>
                </div>
                <div class="divider hiddenUserWindow"></div>
                <div class="usersWindowOtherUsers"></div>
            </div>
        `;
    }
}
